import * as React from 'react';

import ValuePropBulletPoint from 'bundles/enroll-modal/components/subscriptions/ValuePropBulletPoint';
import { getPaidSubscriptionBullets } from 'bundles/enroll-modal/components/subscriptions/free-trialV2/utils/bulletData';

import 'css!./__styles__/SubscriptionVPropBulletPoints';

const SubscriptionVPropBulletPoints = () => {
  const bullets = getPaidSubscriptionBullets();
  return (
    <ul className="rc-SubscriptionVPropBulletPoints nostyle">
      {bullets.map((bullet) => (
        <li key={`bullet_${bullet}`}>
          <ValuePropBulletPoint>
            <p className="body-1-text">{bullet}</p>
          </ValuePropBulletPoint>
        </li>
      ))}
    </ul>
  );
};

export default SubscriptionVPropBulletPoints;
